import React, { useState, useEffect } from "react";
import { getEmiBehavior } from "../API's/Actioncreator";
import Loader from "../../../../presentationals/Loader/Loader.component";
// import Loader from "../../../Component/Common/Loader.component";
import EMIBehaviorCards from "./components/EMIBehaviorCards";
import IncomeBarChart from "../common/IncomeBarChart";
import IncomeDistributionPieChart from "../common/IncomeDistributionPieChart";

import StageWiseAnalysisCards from "./components/StageWiseAnalysisCards";
import EMIStageCollectionChart from "../common/EMIStageCollectionChart";

import moment from "moment";

function EmiBehavour({ selectedMonth, commonFilter }) {
  const [emiBehaviorData, setEmiBehaviorData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch EMI behavior data when selectedMonth changes
  useEffect(() => {
    if (selectedMonth && selectedMonth.length > 0) {
      setLoading(true);
      setError(null);

      const monthMap = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      const sortedMonths = [...selectedMonth].sort((a, b) => {
        const [mA, yA] = a.split(" ");
        const [mB, yB] = b.split(" ");

        return new Date(yA, monthMap[mA]) - new Date(yB, monthMap[mB]);
      });

      const [startMonthName, startYear] = sortedMonths[0].split(" ");
      const [endMonthName, endYear] =
        sortedMonths[sortedMonths.length - 1].split(" ");

      const startMonthIndex = monthMap[startMonthName];
      const endMonthIndex = monthMap[endMonthName];

      // const startDate = `01-${String(startMonthIndex + 1).padStart(2, "0")}-${startYear}`;

      const lastDay = new Date(endYear, endMonthIndex + 1, 0).getDate();
      // const endDate = `${lastDay}-${String(endMonthIndex + 1).padStart(2, "0")}-${endYear}`;

      const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
      const endDate = moment(commonFilter?.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");

      // Fetch EMI behavior data
      new Promise((resolve, reject) => {
        getEmiBehavior(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      })
        .then((response) => {
          setLoading(false);
          if (response.status === 200 && response.data) {
            setEmiBehaviorData(response.data);
          }
        })
        .catch((err) => {
          setLoading(false);
          setError("Failed to fetch EMI behavior data: " + err.message);
        });
    }
  }, [selectedMonth, commonFilter]);

  // Loading state
  if (loading) {
    return <Loader />;
  }

  // Error state
  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        color: '#EF4444',
        fontSize: '16px'
      }}>
        {error}
      </div>
    );
  }

  // Map API data to component structure
  const stages = emiBehaviorData?.stages || [];
  const pieChartData = stages.map(stage => stage.activeLoans);
  const pieChartLabels = stages.map(stage => stage.stageLabel);
  const barChartCategories = stages.map(stage => stage.stageLabel);
  const barChartData = stages.map(stage => stage.collectionRate);
  const totalActiveLoans = emiBehaviorData?.totalActiveLoans || 0;

  return (
    <div>
      <EMIBehaviorCards totalActiveLoans={totalActiveLoans} stages={stages} selectedMonth={selectedMonth} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "30px",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "14px",
            padding: "20px",
            boxShadow:
              "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
          }}
        >
          <IncomeDistributionPieChart
            title="EMI Stage Distribution"
            labels={pieChartLabels}
            series={pieChartData}
            colors={["#3b82f6", "#22c55e", "#f59e0b"]}
            showLegend={true}
          />
        </div>

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "14px",
            padding: "20px",
            boxShadow:
              "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
          }}
        >
          <IncomeBarChart
            title="Collection Rate by EMI Stage"
            gridType="horizontal"
            categories={barChartCategories}
            showLegend={true}
            series={[
              {
                name: "Collection Rate %",
                data: barChartData,
              },
            ]}
            colors={["#10b981"]}
          />
        </div>
      </div>
      <div
        style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "14px",
          padding: "20px",
          boxShadow:
            "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
          marginTop: "40px",
          marginBottom: "40px",
        }}
      >
        <EMIStageCollectionChart stages={stages} />
      </div>
      <StageWiseAnalysisCards stages={stages} />
    </div>
  );
}

export default EmiBehavour;
